import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const HomeLink = memo(() => {
  const { t } = useTranslation();

  return (
    <Link to="/" role="button" className="btn btn-primary btn-lg home-button" aria-label={t('ariaLabels.returnToHome')}>
      {t('Take me back to Home')}
    </Link>
  );
});
